import Modal from "../Modal";
import CommentNewForm from "../../forms/comment/CommentNewForm";
import { useTranslation } from "../../../hooks/useTranslation";

export default function CommentNewModal({show, handleClose, objectId, objectType, callback, title = null}) {
    const { t } = useTranslation();
    const defaultTitle = t("opportunities.notes") + " - " + t("common.create");
    return (
        <Modal title={title || defaultTitle} show={show} handleClose={handleClose}>
            <CommentNewForm handleClose={handleClose} objectId={objectId} objectType={objectType} callback={callback} />
        </Modal>
    );
};